import { trackWebVital } from "./utils/analytics";

/* Core Web Vitals from real visitors (speed brief item 30, 2026-11-03).

   LCP, INP and CLS, each reported once per page view by the web-vitals
   library, go to our own consent-gated analytics (POST /events) with the
   visitor's device class and connection type. Nothing is sent without
   analytics consent, and no third party is involved.

   The library is a separate small chunk, loaded after the app starts. */
export function deviceClass() {
  try {
    return window.matchMedia("(max-width: 700px)").matches ? "phone" : "desktop";
  } catch {
    return "unknown";
  }
}

export function connectionType() {
  const c = typeof navigator !== "undefined" ? navigator.connection : null;
  return (c && c.effectiveType) || "unknown";
}

export function sendVital(metric) {
  trackWebVital(metric.name, metric.value, deviceClass(), connectionType());
}

const reportWebVitals = () =>
  import("web-vitals")
    .then(({ onCLS, onINP, onLCP }) => {
      onLCP(sendVital);
      onINP(sendVital);
      onCLS(sendVital);
    })
    .catch(() => { /* measuring is optional; the page never depends on it */ });

export default reportWebVitals;
